module.exports = __webpack_public_path__ + "static/media/icon-pencil.b7a2ca45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-pencil.svg
// module id = 1570
// module chunks = 0